/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Admin_Roles_CountInputs */

const en_admin_roles_count = /** @type {(inputs: Admin_Roles_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} roles defined`)
};

/**
* | output |
* | --- |
* | "{count} roles defined" |
*
* @param {Admin_Roles_CountInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_roles_count = /** @type {((inputs: Admin_Roles_CountInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Roles_CountInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_roles_count(inputs)
});
export { admin_roles_count as "admin.roles.count" }